
import isMobile from 'ismobilejs'
const imagesLoaded = require('imagesloaded')
import { gsap, ScrollToPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollToPlugin)

import Job from './modules/Job'
import Drawer from './modules/Drawer'
// import parallax from './modules/parallax';
import Device from './modules/Device'
// import Header from './modules/Header';
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Naitei2022 from './modules/Naitei2022'
import Naitei2022single from './modules/Naitei2022single'

let LuminousGallery = require('luminous-lightbox').LuminousGallery

let luminousTrigger = document.querySelectorAll('.luminous')
if (luminousTrigger !== null) {
  new LuminousGallery(luminousTrigger)
}

const drawer = new Drawer()
// parallax();

new Device()

const device = new Device().device

drawer.on('click', hash => {
  ancScroll(hash)
})

// ユーティリティ
const MathUtils = {
  // map number x from range [a, b] to [c, d]
  map: (x, a, b, c, d) => {
    if (x <= a) {
      return c
    }
    if (x >= b) {
      return d
    }
    return ((x - a) * (d - c)) / (b - a) + c
  },
  // linear interpolationx
  lerp: (a, b, n) => (1 - n) * a + n * b,
}

let globalNav = document.querySelectorAll('.global-nav a')
globalNav = Array.prototype.slice.call(globalNav, 0)
globalNav.forEach(element => {
  element.addEventListener('click', eve => {
    let hash = element.getAttribute('href')
    ancScroll(hash)
    eve.preventDefault()
    return false
  })
})

// スムース
const ancScroll = hash => {
  const offset = isMobile(window.navigator).phone ? 90 : 20
  let scrollY = 0
  if (hash !== '#pagetop') {
    let pageYOffset = window.pageYOffset
    let targetY = document.querySelector(hash).getBoundingClientRect().top
    scrollY = pageYOffset + targetY - offset
  }
  // console.log(hash);
  gsap.to(window, {
    duration: 0.6,
    ease: 'power4.out',
    scrollTo: {
      y: scrollY,
    },
  })
  return false
}

const setAncScroll = () => {
  let link = document.querySelectorAll('a[href^="#"]')
  link = Array.prototype.slice.call(link, 0)
  link.forEach(elm => {
    elm.addEventListener('click', eve => {
      let hash = elm.getAttribute('href')
      ancScroll(hash)
      eve.preventDefault()
      return false
    })
  })
}
setAncScroll()

// スクロール値取得
let docScroll
const getPageYScroll = () => {
  docScroll = window.pageYOffset || document.documentElement.scrollTop
  if (docScroll > window.innerHeight * 0.2) {
    document.body.classList.add('scrolled')
  } else {
    document.body.classList.remove('scrolled')
  }
}
window.addEventListener('scroll', getPageYScroll)

function init() {
  if (document.querySelector('.page-member')) {
    memberSingle()
  }
  fadeItems()
  StaggerItems()
}

// Preload images
const preloadImages = () => {
  return new Promise(resolve => {
    const imgLoad = new imagesLoaded(
      document.querySelectorAll('.img'),
      { background: true },
      resolve
    )
    // let pg = document.querySelector('.js-progress');
    imgLoad.on('progress', function(instance) {
      // pg.innerHTML = parseInt(
      // (instance.progressedCount / imgLoad.images.length) * 100
      // );
      // console.log( + ' images loaded');
      // let result = image.isLoaded ? 'loaded' : 'broken';
      // console.log('image is ' + result + ' for ' + image.img.src);
    })
  })
}

// And then..
preloadImages().then(() => {
  document.body.classList.remove('now-loading')
  // console.log('loaded');
  init()
})

// セクション監視
const watchSection = () => {
  let target = document.querySelectorAll('.section')
  const changeState = changes => {
    for (const change of changes) {
      if (change.isIntersecting) {
        change.target.classList.add('is-visible')
        // 解除
        // obj.unobserve(change.target);
      } else {
        change.target.classList.remove('is-visible')
      }
    }
  }
  const option = {
    rootMargin: '-20% 0%',
    threshold: [0],
  }
  // オブザーバー
  let observer = new IntersectionObserver(changeState, option)
  // 監視
  for (let i = 0; i < target.length; i++) {
    observer.observe(target[i])
  }
}

// フェードイン
const fadeItems = () => {
  let target = document.querySelectorAll('.js-fadein')
  // コールバック
  const changeState = (changes, obj) => {
    for (const change of changes) {
      if (change.isIntersecting) {
        // 解除
        obj.unobserve(change.target)
        change.target.classList.add('js-fadein--to')
        change.target.addEventListener('transitionend', e => {
          e.target.classList.remove('js-fadein--to')
          e.target.classList.add('js-fadein--active')
        })
      }
    }
  }
  const option = {
    rootMargin: '-10% 0%',
    threshold: [0],
  }
  // オブザーバー
  if (target) {
    let observer = new IntersectionObserver(changeState, option)
    // 監視
    for (let i = 0; i < target.length; i++) {
      observer.observe(target[i])
    }
  }
}

// フェードイン
const StaggerItems = () => {
  let target = document.querySelector('.js-stagger')
  if(!target) {
    return
  }
  let items = target.querySelectorAll('.js-stagger__item')
  if (target) {
    console.log('hoge')
    gsap.set(items, {
      autoAlpha: 0,
      scale: 0.9,
    })
    // コールバック
    const changeState = (entries, self) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          gsap.to(items, {
            duration: 0.6,
            autoAlpha: 1,
            scale: 1,
            stagger: 0.1,
          })
          // 解除
          self.unobserve(entry.target)
        }
      }
    }
    const option = {
      rootMargin: '-10% 0%',
      threshold: [0],
    }
    // オブザーバー
    let observer = new IntersectionObserver(changeState, option)
    // 監視
    observer.observe(target)
  }
}

// イベントセット
document.addEventListener('DOMContentLoaded', () => {
  watchSection()
})

// フェードイン
const setScrollView = () => {
  let target = document.querySelectorAll('.js-scroll-view')
  // コールバック
  const changeState = (changes, obj) => {
    for (const change of changes) {
      if (change.isIntersecting) {
        // 解除
        obj.unobserve(change.target)
        change.target.classList.add('js-scroll-view--enter')
        change.target.addEventListener('transitionend', e => {
          e.target.classList.remove('js-scroll-view--enter')
          e.target.classList.add('js-scroll-view--to')
        })
      }
    }
  }
  const option = {
    rootMargin: '-10% 0%',
    threshold: [0],
  }
  // オブザーバー
  let observer = new IntersectionObserver(changeState, option)
  // 監視
  for (let i = 0; i < target.length; i++) {
    observer.observe(target[i])
  }
}
setScrollView()

// set スクロールアニメーション
const setScrollAnim = (target, tween, init, rootMargin = '-20% 0%') => {
  if (init) {
    init()
  }
  // コールバック
  const changeState = (changes, obj) => {
    for (const change of changes) {
      if (change.isIntersecting) {
        // 解除
        obj.unobserve(change.target)
        tween()
      }
    }
  }
  const option = {
    rootMargin: rootMargin,
    threshold: [0],
  }
  // オブザーバー
  let observer = new IntersectionObserver(changeState, option)
  // 監視
  observer.observe(target)
}

// 文化・制度
if (document.body.classList.contains('page-culture')) {
  var galleryGroup1 = document.querySelectorAll('.gallery-1')
  if (galleryGroup1 !== null) {
    new LuminousGallery(galleryGroup1)
  }
  var galleryGroup2 = document.querySelectorAll('.gallery-2')
  if (galleryGroup2 !== null) {
    new LuminousGallery(galleryGroup2)
  }
  var galleryGroup3 = document.querySelectorAll('.gallery-3')
  if (galleryGroup3 !== null) {
    new LuminousGallery(galleryGroup3)
  }
  var galleryGroup4 = document.querySelectorAll('.gallery-4')
  if (galleryGroup4 !== null) {
    new LuminousGallery(galleryGroup4)
  }
  var galleryGroup5 = document.querySelectorAll('.gallery-5')
  if (galleryGroup5 !== null) {
    new LuminousGallery(galleryGroup5)
  }
  var galleryGroup6 = document.querySelectorAll('.gallery-6')
  if (galleryGroup6 !== null) {
    new LuminousGallery(galleryGroup6)
  }
  var galleryGroup7 = document.querySelectorAll('.gallery-7')
  if (galleryGroup7 !== null) {
    new LuminousGallery(galleryGroup7)
  }
  var galleryGroup8 = document.querySelectorAll('.gallery-8')
  if (galleryGroup8 !== null) {
    new LuminousGallery(galleryGroup8)
  }
  var galleryGroup9 = document.querySelectorAll('.gallery-9')
  if (galleryGroup9 !== null) {
    new LuminousGallery(galleryGroup9)
  }
  var galleryGroup10 = document.querySelectorAll('.gallery-10')
  if (galleryGroup10 !== null) {
    new LuminousGallery(galleryGroup10)
  }
}

// HOME
if (document.body.classList.contains('home')) {
  // obj 1
  setScrollAnim(
    document.querySelector('.js-anim-trigger--1'),
    () => {
      let tl = gsap.timeline()
      tl.to('.js-anim-target--1', {
        ease: 'expo.in',
        duration: 0.6,
        scale: 1,
        y: 0,
        opacity: 1,
      })
    },
    () => {
      gsap.set('.js-anim-target--1', {
        y: -50,
        scale: 0.7,
        opacity: 0,
      })
    }
  )
  // obj 2
  setScrollAnim(
    document.querySelector('.js-anim-trigger--2'),
    () => {
      let tl = gsap.timeline()
      tl.to('.js-anim-target--2', {
        ease: 'expo.in',
        duration: 0.6,
        rotation: 0,
        scale: 1,
        x: 0,
        opacity: 1,
      })
    },
    () => {
      gsap.set('.js-anim-target--2', {
        scale: 1.3,
        rotation: 20,
        // x: 50,
        opacity: 0,
      })
    }
  )
  // obj 3
  setScrollAnim(
    document.querySelector('.js-anim-trigger--3'),
    () => {
      let tl = gsap.timeline()
      tl.to('.js-anim-target--3', {
        ease: 'expo.in',
        duration: 0.6,
        rotation: 0,
        scale: 1,
        x: 0,
        y: 0,
        opacity: 1,
      })
    },
    () => {
      gsap.set('.js-anim-target--3', {
        scale: 1.8,
        // rotation: 20,
        x: -150,
        y: 150,
        opacity: 0,
      })
    }
  )
  setScrollAnim(
    document.querySelector('.js-anim-trigger--3'),
    () => {
      let tl = gsap.timeline()
      tl.addLabel('start')
      tl.to(
        '.js-anim-target--4',
        {
          ease: 'expo.in',
          duration: 0.9,
          rotation: 0,
          scale: 1,
          x: 0,
          y: 0,
          opacity: 1,
        },
        'start'
      )
    },
    () => {
      gsap.set('.js-anim-target--4', {
        scale: 0.4,
        // rotation: 20,
        x: -150,
        y: 150,
        opacity: 0,
      })
    },
    '-30% 0% -50% 0%'
  )
  setScrollAnim(
    document.querySelector('.js-anim--kv'),
    () => {
      let tl = gsap.timeline()
      tl.addLabel('start')
      tl.to(
        '.js-anim-target--5',
        {
          ease: 'expo.in',
          duration: 0.9,
          rotation: 0,
          scale: 1,
          x: 0,
          y: 0,
          opacity: 1,
        },
        'start'
      )
      tl.to(
        ['.js-bg--l', '.js-bg--r'],
        {
          duration: 0.5,
          backgroundColor: '#d4ca00',
        },
        'start'
      )
      tl.to(
        '.js-bg--l',
        {
          ease: 'power4.in',
          duration: 0.4,
          x: -3,
        },
        'start'
      )
      tl.to(
        '.js-bg--r',
        {
          ease: 'power4.in',
          duration: 0.4,
          x: 3,
        },
        'start'
      )
      tl.to('.js-bg--l', {
        ease: 'power4.inOut',
        duration: 1.2,
        rotation: -30,
      })
      tl.to(
        '.js-bg--r',
        {
          ease: 'power4.inOut',
          duration: 1.2,
          rotation: 30,
        },
        '<'
      )
      tl.addLabel('cue1')
      tl.to(
        '.js-kv',
        {
          ease: 'elastic.out(1, 0.3)',
          duration: 0.8,
          scale: 1,
          opacity: 1,
        },
        'cue1-=0.4'
      )
    },
    () => {
      gsap.set('.js-anim-target--5', {
        scale: 0.4,
        // rotation: 20,
        x: 150,
        y: 150,
        opacity: 0,
      })
      gsap.set('.js-kv', {
        scale: 0.5,
        opacity: 0,
      })
    }
  )
}

function memberSingle() {
  const slide = new Swiper('.js-slider-people', {
    modules: [Navigation, Pagination],
    paginationClickable: true,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 600,
    loop: true,
    slidesPerView: 1.4,
    // autoplay: 5000,
    loopAdditionalSlides: 5,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is <= 320px
      992: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  })
}

if (document.body.classList.contains('page-job')) {
  new Job()
}
